import { render, staticRenderFns } from "./FluidCardSlider.vue?vue&type=template&id=2d2e9ed4&"
import script from "./FluidCardSlider.vue?vue&type=script&lang=ts&"
export * from "./FluidCardSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports